module.exports = __webpack_public_path__ + "img/3d-ref-newest.20cdabd2.jpg";